import React from 'react';

/** Poker chip icon — used for Cash Games tab */
export const PokerChipIcon = ({
  size = 18,
  color = 'currentColor'
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <circle cx='12' cy='12' r='10' stroke={color} strokeWidth='1.5' />
    <circle cx='12' cy='12' r='7' stroke={color} strokeWidth='1' strokeDasharray='3 2' />
    <circle cx='12' cy='12' r='3.5' fill={color} opacity='0.3' />
    <line x1='12' y1='2' x2='12' y2='5' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <line x1='12' y1='19' x2='12' y2='22' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <line x1='2' y1='12' x2='5' y2='12' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <line x1='19' y1='12' x2='22' y2='12' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <line
      x1='4.93'
      y1='4.93'
      x2='6.7'
      y2='6.7'
      stroke={color}
      strokeWidth='1.2'
      strokeLinecap='round'
    />
    <line
      x1='17.3'
      y1='17.3'
      x2='19.07'
      y2='19.07'
      stroke={color}
      strokeWidth='1.2'
      strokeLinecap='round'
    />
    <line
      x1='19.07'
      y1='4.93'
      x2='17.3'
      y2='6.7'
      stroke={color}
      strokeWidth='1.2'
      strokeLinecap='round'
    />
    <line
      x1='6.7'
      y1='17.3'
      x2='4.93'
      y2='19.07'
      stroke={color}
      strokeWidth='1.2'
      strokeLinecap='round'
    />
  </svg>
);

/** Sheriff star / badge icon — used for Tournaments tab */
export const SheriffStarIcon = ({
  size = 18,
  color = 'currentColor'
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M12 2 L14.2 8.5 L21 9.2 L16 13.8 L17.5 21 L12 17.5 L6.5 21 L8 13.8 L3 9.2 L9.8 8.5 Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill={color}
      fillOpacity='0.15'
    />
    <circle
      cx='12'
      cy='12.5'
      r='2.5'
      stroke={color}
      strokeWidth='1'
      fill={color}
      fillOpacity='0.2'
    />
  </svg>
);

/** Spade icon — used for Hold'em pill */
export const SpadeIcon = ({
  size = 14,
  color = 'currentColor'
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill={color}>
    <path d='M12 2 C12 2 3 10 3 14.5 C3 17.5 5.5 19 8 19 C9.5 19 10.8 18.3 11.5 17.2 L11 22 L13 22 L12.5 17.2 C13.2 18.3 14.5 19 16 19 C18.5 19 21 17.5 21 14.5 C21 10 12 2 12 2Z' />
  </svg>
);

/** Four-leaf / diamond icon — used for Omaha pill */
export const DiamondIcon = ({
  size = 14,
  color = 'currentColor'
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill={color}>
    <path d='M12 2 L20 12 L12 22 L4 12 Z' />
  </svg>
);

/** Horseshoe icon — used for lobby/home */
export const HorseshoeIcon = ({
  size = 16,
  color = 'currentColor'
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
    <path
      d='M5 20 L5 10 C5 6.13 8.13 3 12 3 C15.87 3 19 6.13 19 10 L19 20'
      stroke={color}
      strokeWidth='2.5'
      strokeLinecap='round'
      fill='none'
    />
    <circle cx='5' cy='20' r='2' fill={color} />
    <circle cx='19' cy='20' r='2' fill={color} />
  </svg>
);
